var _desc, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-2 -2 64 64",
    id: "Create-Chart--Streamline-Ultimate.svg",
    height: 64,
    width: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Create Chart Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M58.125 53.125c0 2.75 -2.25 5 -5 5H6.875c-2.75 0 -5 -2.25 -5 -5V6.875c0 -2.75 2.25 -5 5 -5h46.25c2.75 0 5 2.25 5 5v46.25Z",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M18.624875 46.125c0 1.5 -1 2.5 -2.5 2.5h-2.5c-1.5 0 -2.5 -1 -2.5 -2.5v-7c0 -1.5 1 -2.5 2.5 -2.5h2.5c1.5 0 2.5 1 2.5 2.5v7Z",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M33.625 46.125c0 1.5 -1 2.5 -2.5 2.5h-2.5c-1.5 0 -2.5 -1 -2.5 -2.5V16.625049999999998c0 -1.5 1 -2.5 2.5 -2.5h2.5c1.5 0 2.5 1 2.5 2.5V46.125Z",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M48.625 46.125c0 1.5 -1 2.5 -2.5 2.5h-2.5c-1.5 0 -2.5 -1 -2.5 -2.5v-17c0 -1.5 1 -2.5 2.5 -2.5h2.5c1.5 0 2.5 1 2.5 2.5v17Z",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.ab78cff8930170413ac91f6c3cb6c4d8.svg";
export { ForwardRef as ReactComponent };